import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {TrustiiService} from 'src/app/services/trustii.service';
import {DialogService} from 'src/app/services/dialog.service';
import {DataService, DatasetBannerModel, DatasetBannerView} from 'src/app/services/data.service';
// Rxjs
import {Observable, of, throwError} from 'rxjs';
import {catchError, map, switchMap, tap} from 'rxjs/operators';
import {SessionService, UserType} from 'src/app/services/session.service';

@Component({
  selector: 'app-vendor-rules',
  templateUrl: './rules.component.html',
  styleUrls: ['./rules.component.scss']
})
export class RulesComponent implements OnInit {
  private params: Params;
  datasetId = 0;
  dataset: any = false;
  link = null;
  enterpriseUser = null;
  inProgress = false;

  constructor(private sessionService: SessionService,
              private router: Router,
              private route: ActivatedRoute,
              private trustiiService: TrustiiService,
              private dialogService: DialogService,
              public dataservice: DataService,
              public datasetBannerModel: DatasetBannerModel) {
  }

  /**
   * Init component
   *
   * @return void
   */
  ngOnInit(): void {
    if (this.dataservice.data.accountId === this.sessionService.getUser().roleId) {
      this.enterpriseUser = true;
    } else {
      this.enterpriseUser = false;
    }
    this.datasetBannerModel.setBannerView(DatasetBannerView.RulesView);
    this._loadParams$()
      .pipe(
        switchMap(this._loadDataset$.bind(this)),
      )
      .subscribe();
  }

  /** _loadParams$ method
   *
   * Load params and set class properties.
   * @return Observable<Params>
   */
  private _loadParams$(): Observable<Params> {
    return this.route.params
      .pipe(
        map((params: Params) => this.params = params)
      );
  }

  /** _loadDataset$ method
   *
   * Load dataset if there is id dataset on params.
   */
  private _loadDataset$(): Observable<any> {
    if (!this.params.datasetId || this.params.datasetId <= 0) {
      return of({});
    }
    this.datasetId = this.params.datasetId;
    return this.trustiiService.getDataset(this.datasetId)
      .pipe(
        map((dataset: any) => this.dataset = dataset.data),
        tap(() => this.downloadTerms()),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  downloadTerms() {
    this.trustiiService.getDatasetTerms(this.datasetId).subscribe(
      (res) => {
        this.link = window.URL.createObjectURL(res);
      },
      (err) => {
        this.dialogService.openAlertDialog(
          '350px',
          'failed to download rules. Please retry again after sometime',
          'ERROR',
          'Ok',
          'modal-warning'
        );
      }
    );
  }

  validateParticipation() {
    this.inProgress = true;
    if (this.dataset.vendorStats && this.dataset.vendorStats.acceptCondition === 0) {
      this.trustiiService.vendorAcceptCondition(this.datasetBannerModel.dataset.id)
      .pipe(
        tap((dataset: any) => this.dataset = dataset.data),
        tap((dataset: any) => Object.assign(this.datasetBannerModel.dataset, dataset.data)),
        tap((dataset: any) => this.dataservice.data = dataset.data),
        tap((dataset: any) => this.inProgress = false),
        catchError((error) => {
          return throwError(error);
        })
      ).subscribe();
    } else {
      this.trustiiService.vendorParticipateDataset(this.datasetBannerModel.dataset.id)
      .pipe(
        tap((dataset: any) => this.dataset = dataset.data),
        tap((dataset: any) => Object.assign(this.datasetBannerModel.dataset, dataset.data)),
        tap((dataset: any) => this.dataservice.data = dataset.data),
        tap((dataset: any) => this.inProgress = false),
        catchError((error) => {
          return throwError(error);
        })
      ).subscribe();
    }
  }
}
